/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Confirm_SavedInputs */



/**
* | output |
* | --- |
* | "I've saved my API key securely" |
*
* @param {Profile_Security_User_Api_Key_Confirm_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_confirm_saved = /** @type {((inputs?: Profile_Security_User_Api_Key_Confirm_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Confirm_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ich habe meinen API-Schlüssel sicher gespeichert")
	return /** @type {LocalizedString} */ ("I've saved my API key securely")
});